"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuyUITypeEnum = void 0;
var BuyUITypeEnum;
(function (BuyUITypeEnum) {
    /** 自定义分组 */
    BuyUITypeEnum["Group"] = "group";
    /** SPU元信息 */
    BuyUITypeEnum["SpuMeta"] = "spu-meta";
})(BuyUITypeEnum || (exports.BuyUITypeEnum = BuyUITypeEnum = {}));
